export enum FeedbackCategory {
  NewFeature = 'New Feature',
  Improvement = 'Improvement',
  Integration = 'Integration',
  UIDesign = 'UI / Design',
  Other = 'Other'
}

export enum FeedbackPriority {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low'
}

export interface IFeedbackAttachment {
  file: File;
  name: string;
  type: string;
  size: number;
}

export interface IFeedback {
  summary: string;
  details?: string;
  category?: FeedbackCategory;
  priority: FeedbackPriority;
  attachments?: IFeedbackAttachment[];
}

export const feedbackCategoryOptions = [
  { 
    label: 'New Feature', 
    value: FeedbackCategory.NewFeature, 
    svgPath: 'M13 10V3L4 14h7v7l9-11h-7z'
  },
  { 
    label: 'Improvement', 
    value: FeedbackCategory.Improvement, 
    svgPath: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
  },
  { 
    label: 'Integration', 
    value: FeedbackCategory.Integration, 
    svgPath: 'M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'
  },
  { 
    label: 'UI / Design', 
    value: FeedbackCategory.UIDesign, 
    svgPath: 'M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01'
  },
  { 
    label: 'Other', 
    value: FeedbackCategory.Other, 
    svgPath: 'M8 12h.01M12 12h.01M16 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
  }
];

export const feedbackPriorityOptions = [
  { 
    label: 'High Priority', 
    value: FeedbackPriority.High, 
    description: 'I really need this',
    color: '#ef4444'
  },
  { 
    label: 'Medium Priority', 
    value: FeedbackPriority.Medium, 
    description: 'Would noticeably improve my experience',
    color: '#f97316'
  },
  { 
    label: 'Low Priority', 
    value: FeedbackPriority.Low, 
    description: 'A nice enhancement for the future',
    color: '#22c55e'
  }
];
